import type { StateCreator } from 'zustand';
import { type StoreState } from '..';
import { signInWithEmail } from 'src/services/cognito';

export interface AuthSlice {
  token: any;
  login: () => Promise<boolean>;
  logout: () => void;
}

export const createAuthSlice: StateCreator<
    StoreState,
    [],
    [],
    AuthSlice
> = (set, get) => ({
    token: "",
    login: async() => {
        try {
        const response: any = await signInWithEmail(process.env.REACT_APP_DEFAULT_USERNAME, process.env.REACT_APP_DEFAULT_PASSWORD);
       
        set((state) => ({
            ...state,
            token: response.accessToken
        }));
        return true;
        } catch (error) {
        console.error('Login error:', error);
        return false;
        }
    },
    logout: async() => {
        set((state) => ({
            ...state,
            token: ""
        }));
    }
});